import { graphql } from '../../graphql';

export const getPayment = graphql(`
  query GetPayment($signedId: String!) {
    paymentStatus(signedId: $signedId) {
      id
      amount
      targetId
      targetType
      isSuccessful
      serviceName
      serviceId
      updatedAt
      paymentMethod
      replenishmentTarget
      cardNotice
      shortPan
    }
  }
`);
